<template>
  <div id="user-settings-container">
    <div id="title-container">
      <h2>Settings</h2>
    </div>
    <v-avatar id="user-avatar" size="100">
      <img :src="userData.avatar" alt="avatar">
    </v-avatar>
    <span id="username">{{ userData.username }}</span>
    <v-list id="preference-list" two-line>
      <v-divider></v-divider>
      <v-subheader v-if='userData.userTier === "OF_T2"'
                   class="v-li-no-padding"
                   v-text="'Member Pages - If you are trying to sign up for new Membership that has moved to OpenBB'"
      ></v-subheader>
      <v-list-item v-if='userData.userTier === "OF_T2"' class="v-li-no-padding" @click="StreamingDP">
        <v-list-item-content>
          <v-list-item-title>Go to the Dark Pool Streaming Page</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click here to see the Dark Pool Flow Page.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-if='userData.userTier === "OF_T2"' class="v-li-no-padding" @click="StreamingFlow">
        <v-list-item-content>
          <v-list-item-title>Go to the Options Streaming Page</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click here to see the Options Flow Page.</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-subheader
              class="v-li-no-padding"
              v-text="'Webhooks'"
      ></v-subheader>
      <v-divider></v-divider>
      <v-subheader
              class="v-li-no-padding"
              v-text="'Server Premium'"
      ></v-subheader>
      <v-list-item v-if="this.serverInfo.nextBillDate != null" class="v-li-no-padding">
        <v-list-item-content>
          <v-list-item-title>Billing Cycle</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Your next payment is on
            {{ this.serverInfo.nextBillDate | formatDate }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-if="this.serverInfo.cancelled === false" class="v-li-no-padding" @click="cancelSubServer">
        <v-list-item-content>
          <v-list-item-title>Cancel Server Subscription</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click this menu item to end your Server Subscription. You'll keep
            access until the next billing cycle.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-if="this.serverInfo.premium === false || this.serverInfo.cancelled === true" class="v-li-no-padding" @click="reSub3">
        <v-list-item-content>
          <v-list-item-title>Start Server Subscription - Discord Only - $149.99/mo</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click this menu item to Start your Discord Server Subscription ($149.99/mo). This will give you unlimited access to all Discord commands in the server you sign up with. Commands will have a short cooldown delay.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
<!--      <v-divider></v-divider>-->
<!--      <v-list-item class="v-li-no-padding" @click="webhooksSub">-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>Webhook Subscription</v-list-item-title>-->
<!--          <v-list-item-subtitle class="v-li-sub-margin">Click here to get started with Webhooks for your Discord server.-->
<!--          </v-list-item-subtitle>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->
<!--      <v-divider></v-divider>-->
<!--      <v-list-item v-if='userData.userWebhooks === "OF_T2"' class="v-li-no-padding" @click="webhooksSub">-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>Cancel Webhook Subscription</v-list-item-title>-->
<!--          <v-list-item-subtitle class="v-li-sub-margin">Click here to cancel your Webhooks.-->
<!--          </v-list-item-subtitle>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->
      <v-divider></v-divider>
      <v-subheader
          class="v-li-no-padding"
          v-text="'Subscription'"
      ></v-subheader>
      <v-list-item v-if="userData.premium === true" class="v-li-no-padding">
        <v-list-item-content>
          <v-list-item-title>Billing Cycle</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Your next payment is on
            {{ userData.nextBillDate | formatDate }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="v-li-no-padding">
        <v-list-item-content>
          <v-list-item-title>Subscription Date</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Your subscription started on
            {{ userData.paidDate | formatDate }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="v-li-no-padding">
        <v-list-item-content>
          <v-list-item-title>Registration Date</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Your account was created on
            {{ userData.createdDate | formatDate }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-if="userData.cancelled === false" class="v-li-no-padding" @click="cancelSub">
        <v-list-item-content>
          <v-list-item-title>Cancel Subscription</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click this menu item to end your subscription. You'll keep
            access until the next billing cycle.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="v-li-no-padding" @click="logout">
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
          <v-list-item-subtitle class="v-li-sub-margin">Click this menu item to logout of your account.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

  </div>
</template>

<script>
import {BASE_URL} from "../../utils/constants";
import {checkCookie, COOKIE_USER_AUTH, COOKIE_USER_ID, getCookie, deleteCookie} from "../../utils/CookieHelper";
import {mapActions, mapGetters, mapState} from "vuex";

const ENDPOINT = "api/v1/users/"
const ENDPOINTSERVER = "api/v1/servers/"
const CANCEL_ENDPOINT = "api/v1/stopsub"
const CANCEL_ENDPOINT_SERVERS = "api/v1/stopsubServer"
//const RESUB_ENDPOINT = "api/v1/reSub"

export default {
  name: "UserSettings",
  mounted() {
    // Send user back if not logged in
    if (!checkCookie(COOKIE_USER_ID) || !checkCookie(COOKIE_USER_AUTH)) {
      this.$router.push({name: "Login"})
    }

    this.getProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH))
    this.getServerProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH))
  },
  computed: mapState('user', [
    'userData'
  ]),
  methods: {
    ...mapActions('user', [
      'changeUserData',
    ]),
    ...mapGetters('user', [
      'userMetaData'
    ]),
    getProfile: function (userCookie, authCookie) {
      fetch(BASE_URL + ENDPOINT + userCookie, {
        headers: {
          "x-access-token": authCookie
        }
      }).then(response => {
        return response.json();
      }).then(data => {
        let userInfo = {
          username: data[0]['username'],
          avatar: `https://cdn.discordapp.com/avatars/${data[0]['userid']}/${data[0]['avatar']}.jpg`,
          nextBillDate: data[0]['nextBillDate'],
          paidDate: data[0]['paidDate'],
          createdDate: data[0]['createdDate'],
          cancelled: data[0]['hasCancelled'],
          subIDcurrent: data[0]['subID'],
          userEmail: data[0]['email'],
          userID: data[0]['userid'],
          userTier: data[0]['userTier'],
          premium: data[0]['premium'],
          userWebhooks: "test",
        }
        this.changeUserData(userInfo);
      }).catch(error => {
        console.log(error);
      })
    },
    getServerProfile: function (userCookie, authCookie) {
      fetch(BASE_URL + ENDPOINTSERVER + userCookie, {
        headers: {
          "x-access-token": authCookie
        }
      }).then(response => {
          return response.json();
      }).then(data => {

        if (data.length > 0) {
          this.serverInfo = {
            nextBillDate: data[0]['nextBillDate'],
            paidDate: data[0]['paidDate'],
            createdDate: data[0]['createdDate'],
            cancelled: data[0]['hasCancelled'],
            subIDcurrent: data[0]['subID'],
            userID: data[0]['userid'],
            premium: data[0]['premium'],
          }
        }else{
          this.serverInfo = {
            nextBillDate: "",
            paidDate: null,
            createdDate: "",
            cancelled: true,
            subIDcurrent: "",
            userID: "",
            premium: false,
          }
        }
      }).catch(error => {
        console.log(error);
      })
    },
    cancelSub: function () {
      let postBody = {
        subID: this.userData.subIDcurrent,
        userID: this.userData.userID
      }
      this.$confirm("Are you sure? You will still have access til the end of your Subscription Date.").then(() => {
        fetch(BASE_URL + CANCEL_ENDPOINT, {
          headers: {
            "x-access-token": getCookie(COOKIE_USER_AUTH),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'post',
          body: JSON.stringify(postBody)
        })
            .then(response => {

              if (response.ok) {
                this.$alert(
                    "Your Sub has been successfully cancelled. Thanks for using OFB Prem.",
                    "Success",
                    "success"
                ).then(() => {
                  window.location.reload();
                  this.getProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH));
                });

              } else {
                this.$alert(
                    "Error! Please Email - optionsfambot@gmail.com with your username/email you used to sign up and a description of what you tried to do.",
                    "Error",
                    "error"
                )
              }
            })
            .catch(error => {
              console.log(error);
              this.$alert(
                  "Error! Please Email - optionsfambot@gmail.com with your username/email you used to sign up and a description of what you tried to do.",
                  "Error",
                  "error"
              )
            })
      }).catch(error => {
        console.log(error);
      });

    },
    cancelSubServer: function () {
      let postBody = {
        subID: this.serverInfo.subIDcurrent,
        userID: this.serverInfo.userID
      }
      this.$confirm("Are you sure? You will still have access til the end of your Subscription Date.").then(() => {
        fetch(BASE_URL + CANCEL_ENDPOINT_SERVERS, {
          headers: {
            "x-access-token": getCookie(COOKIE_USER_AUTH),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'post',
          body: JSON.stringify(postBody)
        })
                .then(response => {

                  if (response.ok) {
                    this.$alert(
                            "Your Sub has been successfully cancelled. Thanks for using OFB Server Premium.",
                            "Success",
                            "success"
                    ).then(() => {
                      window.location.reload();
                      this.getProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH));
                      this.getServerProfile(getCookie(COOKIE_USER_ID), getCookie(COOKIE_USER_AUTH));
                    });

                  } else {
                    this.$alert(
                            "Error! Please Email - optionsfambot@gmail.com with your username/email you used to sign up and a description of what you tried to do.",
                            "Error",
                            "error"
                    )
                  }
                })
                .catch(error => {
                  console.log(error);
                  this.$alert(
                          "Error! Please Email - optionsfambot@gmail.com with your username/email you used to sign up and a description of what you tried to do.",
                          "Error",
                          "error"
                  )
                })
      }).catch(error => {
        console.log(error);
      });

    },
    StreamingDP: function () {
      this.$router.push({name: "DarkPoolFlow", params: {userID: this.userData.userID}})
    },
    StreamingFlow: function () {
      this.$router.push({name: "OptionsFlow", params: {userID: this.userData.userID}})
    },
    // webhooksSub: function () {
    //   this.$router.push({name: "Webhooks", params: {userID: this.userData.userID, userEmail: this.userData.userEmail}})
    // },
    // reSub1: function () {
    //   this.$router.push({name: "PaymentReSub", params: {planID: "OF_T1", userID: this.userData.userID, userEmail: this.userData.userEmail}})
    // },
    // reSub2: function () {
    //   this.$router.push({name: "PaymentReSub", params: {planID: "OF_T2", userID: this.userData.userID, userEmail: this.userData.userEmail}})
    // },
    // reSub3: function () {
    //   this.$router.push({name: "PaymentReSubServer", params: {planID: "OF_T3", userID: this.userData.userID, userEmail: this.userData.userEmail}})
    // },
    // upgradeSub: function () {
    //   this.$router.push({name: "PaymentUpgradeSub", params: {planID: "OF_T1", newPlanID: "OF_T2", userID: this.userData.userID, subID : this.userData.subIDcurrent}})
    // },
    // downgradeSub: function () {
    //   this.$router.push({name: "PaymentUpgradeSub", params: {planID: "OF_T2", newPlanID: "OF_T1", userID: this.userData.userID, subID : this.userData.subIDcurrent}})
    // },
    logout: function () {
      deleteCookie(COOKIE_USER_AUTH);
      deleteCookie(COOKIE_USER_ID);
      this.$router.push({name: "Home"});
    }
  },
  data: () => ({
    serverInfo : {}
  }),
}
</script>

<style scoped>
h2 {
  font-size: 26px;
}

#user-settings-container {
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding: 16px;
}

#title-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 2rem;
}

#username {
  font-size: 22px;
  margin-top: 1rem;
}

#tier {
  font-size: 20px;
  color: #C2C2C2;
  margin-top: 0.5rem;
}

#preference-list {
  width: 100%;
  background-color: transparent;
}

.v-li-no-padding {
  padding: 0;
  color: aqua;
}

.v-li-sub-margin {
  margin-top: 0.5rem;
  white-space: normal;
}
</style>